import { render, staticRenderFns } from "./AllComments.vue?vue&type=template&id=6b129cd7&scoped=true"
import script from "./AllComments.vue?vue&type=script&lang=js"
export * from "./AllComments.vue?vue&type=script&lang=js"
import style0 from "./AllComments.vue?vue&type=style&index=0&id=6b129cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b129cd7",
  null
  
)

export default component.exports